import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/one-rep-max-calculator',
  component: () => import('../../routes/OneRepMaxCalculator.svelte'),
  card: {
    id: 'one-rep-max',
    title: 'One Rep Max',
    description:
      'Estimate your one rep max (1RM) from any weight and rep range using 7 different strength training formulas.',
    icon: 'fitness_center',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/one-rep-max-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'One Rep Max (1RM) Calculator – Estimate Your Max Lift',
    description:
      'Free one rep max calculator to estimate your 1RM from any weight and reps. Uses Epley, Brzycki, Lander, Lombardi, Mayhew, O\'Conner, and Wathan formulas with a training percentage table.',
  },
};

export default meta;
